import {AttributeChangeRequest} from 'src/openapi/models/AttributeChangeRequest';

const MIN_ATTRIBUTES = 1;

export const attributeValidation = (attributes: AttributeChangeRequest[]): string[] => {
    const errorMassages = [];

    if (attributes.length < MIN_ATTRIBUTES) {
        errorMassages.push(
            `No added attribute. "Event" must have at least ${MIN_ATTRIBUTES} attribute${MIN_ATTRIBUTES > 1 ? 's' : ''}`,
        );
    }

    return errorMassages;
};
